<template>
  <!-- 登録確認 -->
  <ModalDialog
    :pop-name="list[id]"
    dialog-height="auto"
    dialog-width="470px"
    @close="closeModal"
  >
    <template #header> </template>

    <template #body>
      <div v-if="id === 0">
        <div class="d-flex">
          <div class="col-3"></div>
          <div class="col-9">
            <div class="col-12 mtp-3 d-flex">
              入力した情報が反映されていません。
            </div>
            <div class="col-12 d-flex mtp-1">画面を離れますか？</div>
          </div>
        </div>
      </div>
      <div v-if="id === 1">
        <div class="d-flex">
          <div class="col-2"></div>
          <div class="col-10">
            <div class="d-flex mtp-3">
              処理を続行すると編集中のデータが破棄されます。
            </div>
            <div class="col-12 d-flex mtp-1">
              予め登録処理を行ってください。
            </div>
            <div class="col-12 d-flex mtp-1">処理を続行しますか？</div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="d-flex justify-content-center mtp-3 mbm-3">
        <ButtonMain button-name="OK" @click="ok"></ButtonMain>
        <ButtonNormal
          class="ms-4"
          button-name="キャンセル"
          @click="cancel"
        ></ButtonNormal>
      </div>
    </template>
  </ModalDialog>
</template>
<script>
export default {
  name: 'RegistrationConfirmation',
  props: {},
  data() {
    return {
      id: 0,
      list: ['登録確認', '編集中断確認']
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    ok() {
      this.$emit('yes')
    },
    cancel() {
      this.$emit('no')
    }
  }
}
</script>
<style scoped lang="scss"></style>
